import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";

import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
  Badge,
  IconButton,
  Popover,
  FormControl,
  InputLabel,
  FormHelperText,
  MenuItem,
  Select,
  ButtonGroup,
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  CircularProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Divider,
  Menu,
  Chip,
  useMediaQuery,
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  FilterList,
  Store,
  SupervisedUserCircle,
  ArrowForwardIos,
  AssistantPhoto,
  Close,
  CheckCircle,
  Block,
  Edit,
  Delete,
  Folder,
  Description,
  FolderOpen,
  CreateNewFolder,
  Assignment,
  Attachment,
  GetApp,
  Unarchive,
  ArrowBack,
  Label,
  Search,
  MoreVert,
  AttachMoney,
  CallMade,
  CalendarViewDay,
  ArrowDropDown,
  HighlightOff,
  CheckBox,
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import { Skeleton, Pagination, Autocomplete } from "@material-ui/lab";
import MUIDataTable from "mui-datatables";

import { makeStyles, useTheme } from "@material-ui/styles";

import Dropzone from "react-dropzone";

import {
  FinanceService,
  AdminService,
  ReportingService,
  Validator,
  Permissions,
} from "../../../utils/web_config";

import Empty from "../../../assets/svg/empty.svg";

import { useSnackbar } from "notistack";

import { useOrganizations } from "../hooks/use_hooks";

const axios = require("axios");
var FormData = require("form-data");
var fs = require("fs");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    borderRadius: 15,
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
  card: {
    borderRadius: 15,
    padding: 5,
  },
}));

function Inventory(props) {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));

  const orgs = useOrganizations();

  const [accountData, setAccountData] = useState({});
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [menuOpen, setMenuOpen] = useState(null);

  const [anchorEl, setAnchorEl] = useState({ anchor: null, menu: 0 });

  const [allItems, setAllItems] = useState({
    loading: false,
    saving: false,
    status: "Loading all items...",
    toggling: false,
    data: [],
  });
  const [stocks, setStocks] = useState({
    loading: false,
    saving: false,
    open: false,
    data: [],
  });

  const [allItemTypes, setAllItemTypes] = useState({
    loading: false,
    saving: false,
    open: false,
    data: [],
  });

  const [stockItems, setStockItems] = useState({
    loading: false,
    saving: false,
    open: false,
    data: [],
    newData: [],
  });

  const [distribution, setDistribution] = useState({
    loading: false,
    saving: false,
    data: [],
  });

  const [searchMode, setSearchMode] = useState(false);

  const [stockOrganization, setOrganization] = useState({
    value: {},
    error: "",
  });

  const [orderOrganization, setOrganization2] = useState({
    value: {},
    error: "",
  });

  const [stockItem, setItem] = useState({ value: "", error: "" });

  /////////////
  const [itemName, setName] = useState({ value: "", error: "" });
  const [itemPrice, setPrice] = useState({ value: "", error: "" });
  const [itemType, setType] = useState({ value: "", error: "" });

  const [itemSerialNumber, setSerialNumber] = useState({
    value: "",
    error: "",
  });
  /////
  // const [typeName, setTypeName] = useState({ value: "", error: "" });
  const [typeDescription, setTypeDescription] = useState({
    value: "",
    error: "",
  });
  const [itemTypeName, setTypeName] = useState({ value: "", error: "" });

  const [batchNumber, setNumber] = useState({ value: "", error: "" });
  const [batchSize, setSize] = useState({ value: "", error: "" });
  const [batchStartItem, setStartItem] = useState({ value: "", error: "" });
  const [batchEndItem, setEndItem] = useState({ value: "", error: "" });
  const [batchDamagedQuantity, setDamagedQuantity] = useState({
    value: "",
    error: "",
  });

  const [choosenFile, setChoosenFile] = useState([]);
  const [serials, setSerials] = useState({ items: [] });
  const [movement, setMovement] = useState(null);

  useEffect(() => {
    const data = new AdminService().accountData;
    setAccountData(data);

    getStoks(data.token);
    getAllItems(data.token);
    getItemTypes(data.token);
  }, []);

  //////

  const onOrganizationChange = (event, v) => {
    if (v?.organization_id == null) {
      setOrganization({
        value: {},
        error: (
          <Translate>
            {({ translate }) =>
              translate("inventory.forms.hints.stock_organization")
            }
          </Translate>
        ),
      });
    } else {
      setOrganization({ value: v, error: "" });
    }
  };

  const onOrganizationChange2 = (event, v) => {
    if (v?.organization_id == null) {
      setOrganization2({
        value: {},
        error: (
          <Translate>
            {({ translate }) =>
              translate("inventory.forms.hints.stock_organization")
            }
          </Translate>
        ),
      });
    } else {
      setOrganization2({ value: v, error: "" });
    }
  };
  const onItemChange = (event) => {
    if (event.target.value === "") {
      setItem({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("inventory.forms.hints.stock_item")}
          </Translate>
        ),
      });
    } else {
      setItem({ value: event.target.value, error: "" });
    }
  };
  /////////////////////////////
  const onNameChange = (event) => {
    if (event.target.value === "") {
      setName({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("inventory.forms.hints.item_name")}
          </Translate>
        ),
      });
    } else {
      setName({ value: event.target.value, error: "" });
    }
  };
  const onPriceChange = (event) => {
    if (event.target.value === "") {
      setPrice({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("inventory.forms.hints.item_price")}
          </Translate>
        ),
      });
    } else {
      setPrice({ value: event.target.value, error: "" });
    }
  };
  const onTypeChange = (event) => {
    if (event.target.value === "") {
      setType({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("inventory.forms.hints.item_type")}
          </Translate>
        ),
      });
    } else {
      setType({ value: event.target.value, error: "" });
    }
  };

  const onTypeNameChange = (event) => {
    if (event.target.value === "") {
      setTypeName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("inventory.forms.hints.item_type_name")
            }
          </Translate>
        ),
      });
    } else {
      setTypeName({ value: event.target.value, error: "" });
    }
  };

  const onSerialNumberChange = (event) => {
    if (event.target.value === "") {
      setSerialNumber({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("inventory.forms.hints.item_serial_number")
            }
          </Translate>
        ),
      });
    } else {
      setSerialNumber({ value: event.target.value, error: "" });
    }
  };

  // const onTypeNameChange = (event) => {
  //   if (event.target.value === "") {
  //     setTypeName({
  //       value: "",
  //       error: (
  //         <Translate>
  //           {({ translate }) => translate("inventory.forms.hints.type_name")}
  //         </Translate>
  //       ),
  //     });
  //   } else {
  //     setTypeName({ value: event.target.value, error: "" });
  //   }
  // };
  const onTypeDescriptionChange = (event) => {
    if (event.target.value === "") {
      setTypeDescription({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("inventory.forms.hints.type_description")
            }
          </Translate>
        ),
      });
    } else {
      setTypeDescription({ value: event.target.value, error: "" });
    }
  };

  /////////////////////////////////////////

  const onNumberChange = (event) => {
    if (event.target.value === "") {
      setNumber({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("inventory.forms.hints.batch_number")}
          </Translate>
        ),
      });
    } else {
      setNumber({ value: event.target.value, error: "" });
    }
  };
  const onSizeChange = (event) => {
    if (event.target.value === "") {
      setSize({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("inventory.forms.hints.batch_size")}
          </Translate>
        ),
      });
    } else {
      setSize({ value: event.target.value, error: "" });
    }
  };
  const onStartItemChange = (event) => {
    if (event.target.value === "") {
      setStartItem({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("inventory.forms.hints.batch_start_item")
            }
          </Translate>
        ),
      });
    } else {
      setStartItem({ value: event.target.value, error: "" });
    }
  };
  const onEndItemChange = (event) => {
    if (event.target.value === "") {
      setEndItem({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("inventory.forms.hints.batch_end_item")
            }
          </Translate>
        ),
      });
    } else {
      setEndItem({ value: event.target.value, error: "" });
    }
  };
  const onDamagedQuantityChange = (event) => {
    if (event.target.value === "") {
      setDamagedQuantity({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("inventory.forms.hints.batch_damaged_quantity")
            }
          </Translate>
        ),
      });
    } else {
      setDamagedQuantity({ value: event.target.value, error: "" });
    }
  };

  //////////////////////////////////////

  const onCreateBatchClick = () => {
    if (batchNumber.value === "") {
      setNumber({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("inventory.forms.hints.batch_number")}
          </Translate>
        ),
      });
    } else if (batchSize.value === "") {
      setSize({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("inventory.forms.hints.batch_size")}
          </Translate>
        ),
      });
    } else if (batchStartItem.value === "") {
      setStartItem({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("inventory.forms.hints.batch_start_item")
            }
          </Translate>
        ),
      });
    } else if (batchEndItem.value === "") {
      setEndItem({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("inventory.forms.hints.batch_end_item")
            }
          </Translate>
        ),
      });
    } else if (batchDamagedQuantity.value === "") {
      setDamagedQuantity({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("inventory.forms.hints.batch_damaged_quantity")
            }
          </Translate>
        ),
      });
    } else {
      addBatches();
    }
  };

  const onSerialFormSubmit = (e) => {
    e.preventDefault();

    if (itemSerialNumber.value === "") {
      setSerialNumber({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("inventory.forms.hints.item_serial_number")
            }
          </Translate>
        ),
      });
    } else {
      const serials = stockItems.newData;

      var count = serials.filter((obj) => obj.serial == itemSerialNumber.value)
        .length;

      if (count != 0) {
        setSerialNumber({
          value: itemSerialNumber.value,
          error: "This item already added",
        });
        return;
      }
      serials.unshift({ serial: itemSerialNumber.value, damaged: false });
      setStockItems({ ...stockItems, newData: serials });

      setSerialNumber({
        value: "",
        error: "",
      });

      setChoosenFile([]);
    }
  };

  const removeItemSerial = (i) => {
    const serials = stockItems.newData;
    serials.splice(i, 1);

    setStockItems({ ...stockItems, newData: serials });
  };

  ///////////////////////////////////////
  const onCreateItemClick = () => {
    if (itemType.value === "") {
      setType({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("inventory.forms.hints.item_type")}
          </Translate>
        ),
      });
    } else if (itemName.value === "") {
      setName({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("inventory.forms.hints.item_name")}
          </Translate>
        ),
      });
    } else if (itemPrice.value === "") {
      setPrice({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("inventory.forms.hints.item_price")}
          </Translate>
        ),
      });
    } else {
      createItem();
    }
  };
  //////////////////////////

  const onCreateStockClick = () => {
    if (stockOrganization.value.organization_id == null) {
      setOrganization({
        value: {},
        error: (
          <Translate>
            {({ translate }) =>
              translate("inventory.forms.hints.stock_organization")
            }
          </Translate>
        ),
      });
    } else if (stockItem.value === "") {
      setItem({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("inventory.forms.hints.stock_item")}
          </Translate>
        ),
      });
    } else {
      createStock();
    }
  };

  //////////////////

  const onCreateTypeClick = () => {
    if (itemTypeName.value === "") {
      setTypeName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("inventory.forms.hints.item_type_name")
            }
          </Translate>
        ),
      });
    } else if (typeDescription.value === "") {
      setTypeDescription({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("inventory.forms.hints.type_description")
            }
          </Translate>
        ),
      });
    } else {
      createItemType();
    }
  };

  const columns = [
    {
      name: "id",
      label: "Item id",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "name",
      label: "Item name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "unitPrice",
      label: "Unit price",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => (
          <span>{new Validator().formatMoney(value)}</span>
        ),
      },
    },
    {
      name: "itemTypeName",
      label: "Item type",
      options: {
        filter: false,
        sort: false,
      },
    },
  ];

  const options = {
    filterType: "multiselect",
    elevation: 0,
    selectableRows: "single",
    searchPlaceholder: "Search item...",
    selectableRowsOnClick: true,
    fixedHeader: true,
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: allItems.status,
      },
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      //  <CustomUsersToolbar
      //    selectedRows={selectedRows}
      //    displayData={displayData}
      //    setSelectedRows={setSelectedRows}
      //    toggleUser={toggleUser}
      //    openEdit={showUserEdit}
      //    toggling={allItems.toggling}
      //  />
      <></>
    ),
  };

  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  const capitalize = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };

  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      console.log(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  }
  /////////////////////////////////////

  const getItemTypes = (token) => {
    const typesInstance = axios.create(new AdminService().getHeaders(token));

    typesInstance
      .get(new ReportingService().GET_ITEM_TYPES)
      .then(function (response) {
        const d = response.data;

        if (d?.length == 0) {
          setAllItemTypes({ ...allItemTypes, data: [], status: "empty" });
        } else {
          setAllItemTypes({ ...allItemTypes, data: d, status: "success" });
        }
      })
      .catch(function (error) {
        if (error.response) {
          if (error?.response?.status == 404) {
            setAllItemTypes({ ...allItemTypes, data: [], status: "empty" });
          } else {
            setAllItemTypes({ ...allItemTypes, data: [], status: "error" });
          }
        } else {
          setAllItemTypes({ ...allItemTypes, data: [], status: "error" });
        }
      });

    ////
  };

  ///////////////////////////////////

  const getStoks = (token) => {
    const stkInstance = axios.create(new AdminService().getHeaders(token));

    setStocks({ ...stocks, loading: true });

    console.log("getting stocks .....");

    stkInstance
      .get(new ReportingService().GET_ALL_STOCKS)
      .then(function (response) {
        setStocks({ ...stocks, loading: false });

        const d = response.data.data?.records;

        if (d.length == 0) {
          setStocks({ ...stocks, status: "There are no stocks available" });
        } else {
          var st = stocks.data;

          d.forEach((s, i) => {
            st.push(s);
          });

          setStocks({ ...stocks, data: st });
        }
      })
      .catch(function (error) {
        setStocks({ ...stocks, loading: false });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setStocks({ ...stocks, status: e });

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  ///////////////////////////////////

  const getAllItems = (token) => {
    const itemsInstance = axios.create(new AdminService().getHeaders(token));

    setAllItems({ ...allItems, loading: true });

    console.log("getting allItems .....");

    itemsInstance
      .get(new ReportingService().GET_ITEMS)
      .then(function (response) {
        setAllItems({ ...allItems, loading: false });

        const d = response;

        if (d.data.length == 0) {
          setAllItems({ ...allItems, status: "No items available" });
        } else {
          setAllItems({
            ...allItems,
            data: d.data,
          });
        }
      })
      .catch(function (error) {
        setAllItems({ ...allItems, loading: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setAllItems({ ...allItems, status: e });

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  ///////////////////////////////////

  const getStockItem = () => {
    const itemsInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setStockItems({ ...stockItems, newData: [], open: false, loading: true });

    var data = {
      organization_id: stockItems.selected.organizationId,
      item_id: stockItems.selected.itemId,
    };

    console.log("getting one item .....");

    itemsInstance
      .post(new ReportingService().GET_STOCK_ITEM, data)
      .then(function (response) {
        setStockItems({
          ...stockItems,
          newData: [],
          loading: false,
          open: false,
        });

        const d = response.data;

        const stks = stocks.data;
        stks[stockItems.index] = d.data;

        setStocks({
          ...stocks,
          data: stks,
        });

        setStockItems({
          ...stockItems,
          selected: d.data,
          newData: [],
          open: false,
        });
      })
      .catch(function (error) {
        setStockItems({ ...stockItems, loading: false, open: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  //////////////////////////////////

  const createStock = () => {
    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setStocks({ ...stocks, saving: true });

    const data = {
      organization_type: stockOrganization.value.organization_type,
      organization_id: stockOrganization.value.organization_id,
      item_id: stockItem.value,
      reorder_level: 50,
    };

    console.log("Creating stock .....");

    createInstance
      .post(new ReportingService().CREATE_STOCK, data)
      .then(function (response) {
        //console.log(response);
        setStocks({ ...stocks, saving: false });
        var d = response.data;

        var stks = stocks.data;

        stks.unshift(d.data);

        setStocks({
          ...stocks,
          data: stks,
          open: false,
        });

        setOrganization({ value: {}, error: "" });
        setItem({ value: "", error: "" });

        notify("success", response.data.message);
      })
      .catch(function (error) {
        setStocks({ ...stocks, saving: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  //////////////////////////////////

  const createItem = () => {
    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setAllItems({ ...allItems, saving: true });

    const data = {
      name: itemName.value,
      unit_price: itemPrice.value,
      item_type_id: itemType.value,
      is_serial: true,
    };

    console.log("Creating item .....");

    createInstance
      .post(new ReportingService().CREATE_ITEM, data)
      .then(function (response) {
        setAllItems({ ...allItems, saving: false });
        var d = response.data;

        var itms = allItems.data;

        itms.unshift(d.data);
        setAllItems({
          ...allItems,
          data: itms,
          open: false,
        });

        setName({ value: "", error: "" });
        setPrice({ value: "", error: "" });
        setType({ value: "", error: "" });

        notify("success", response.data.message);
      })
      .catch(function (error) {
        setAllItems({ ...allItems, saving: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  //////////////////////////////////

  const createItemType = () => {
    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setAllItemTypes({ ...allItemTypes, saving: true });

    const data = {
      name: itemTypeName.value,
      description: typeDescription.value,
    };

    console.log("Creating item type .....");

    createInstance
      .post(new ReportingService().CREATE_ITEM_TYPE, data)
      .then(function (response) {
        setAllItemTypes({ ...allItemTypes, saving: false });
        var d = response.data;

        var itms = allItemTypes.data;

        itms.unshift(d.data);
        setAllItemTypes({
          ...allItems,
          data: itms,
          open: true,
          acnhor: null,
        });

        setTypeName({ value: "", error: "" });
        setTypeDescription({ value: "", error: "" });

        notify("success", response.data.message);
      })
      .catch(function (error) {
        setAllItemTypes({ ...allItemTypes, saving: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  ////////////////////////
  const onUploadItemsClick = () => {
    if (choosenFile.length == 0) {
      notify("error", "Please select file to upload items");
    } else {
      const createInstance = axios.create({
        ...new AdminService().getHeaders(accountData.token),
        "Content-Type": "multipart/form-data",
      });

      var data = new FormData();

      data.append("file", choosenFile[0]);
      data.append("item_id", stockItems.selected.itemId);
      data.append("movement_type", "STOCK_IN");
      data.append("organization_id", stockItems.selected.organizationId);

      setStockItems({ ...stockItems, saving: true });

      console.log("Uploading items.....");

      createInstance
        .post(new ReportingService().UPLOAD_CARDS, data)
        .then(function (response) {
          console.log(response.data);
          setStockItems({ ...stockItems, saving: false });
          var d = response.data;

          notify("success", response.data.message);
        })
        .catch(function (error) {
          console.log(error);
          setStockItems({ ...stockItems, saving: false });
          var e = error.message;

          if (error.response) {
            e = error.response.data.message;
          }

          notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
        });
    }
  };

  ////////////////////////
  const addBatches = () => {
    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    const data = {
      movement_type: "STOCK_IN",
      organization_id: stockItems.selected.organizationId,
      provider_id: stockItems.selected.organizationId,
      batches: [
        {
          item_id: stockItems.selected.itemId,
          batch_number: batchNumber.value,
          size: batchSize.value,
          start_number: batchStartItem.value,
          end_number: batchEndItem.value,
          quantity: batchSize.value,
          damaged_quantity: batchDamagedQuantity.value,
          carton_no: "",
          box_no: ""
        },
      ],
    };

    setStockItems({ ...stockItems, saving: true });

    console.log("Adding batches .....");

    createInstance
      .post(new ReportingService().ADD_STOCK, data)
      .then(function (response) {
        console.log(response.data);
        setStockItems({ ...stockItems, saving: false });
        var d = response.data;

        var stks = stocks.data;

        // stks[stockItems.index] = d.data[0];
        // console.log(stks);

        setStocks({
          ...stocks,
          data: stks,
        });

        setStockItems({
          ...stockItems,
          newData: [],
          open: false,
        });

        notify("success", response.data.message);
      })
      .catch(function (error) {
        console.log(error);
        setStockItems({ ...stockItems, saving: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };
  //////////////////////

  const onAddItemsClick = () => {
    if (stockItems.newData.length == 0) {
      notify(
        "warning",
        "Please add items item serial numbers to add them to stock"
      );
    } else {
      const createInstance = axios.create(
        new AdminService().getHeaders(accountData.token)
      );

      const its = stockItems.newData;
      const damaged = its.filter((obj) => obj.damaged == true);

      const serials = [];
      const d_serials = [];

      its.forEach((it, i) => {
        serials.push(it.serial);
      });

      damaged.forEach((it2, i) => {
        d_serials.push(it2.serial);
      });

      var data = {
        movement_type: "STOCK_IN",
        organization_id: stockItems.selected.organizationId,
        provider_id: stockItems.selected.organizationId,
        items: [
          {
            item_id: stockItems.selected.itemId,
            item_type:stockItems.selected?.itemTypeName,
            quantity: its.length,
            serial_numbers: serials,
            damaged_quantity: damaged.length,
            damaged_serial_numbers: d_serials,
          },
        ],
      };

      console.log("-----------------------Sent data--------------------")
      console.log(JSON.stringify(data))

      setStockItems({ ...stockItems, saving: true });

      console.log("Adding items .....");

      createInstance
        .post(new ReportingService().ADD_STOCK, data)
        .then(function (response) {
          setStockItems({
            ...stockItems,
            saving: false,
            newData: [],
            open: false,
          });
          var d = response.data;

          setChoosenFile([]);

          notify("success", response.data.message);

          setTimeout(() => {
            getStockItem();
          }, 1000);
        })
        .catch(function (error) {
          setStockItems({ ...stockItems, saving: false });
          var e = error.message;

          if (error.response) {
            e = error.response.data.message;
          }

          notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
        });
    }
  };

  ////////////////////////
  const requestStock = () => {
    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    const data = {
      movement_type: "STOCK_ORDER",
      organization_id: orderOrganization.value.organization_id,
      provider_id: stockItems.selected.organizationId,
      items: [
        {
          item_id: stockItems.selected.itemId,
          quantity: serials.items?.length,
        },
      ],
    };

    setDistribution({
      ...distribution,
      saving: true,
      status: "Requesting items...",
    });

    createInstance
      .post(new ReportingService().REQUEST_STOCK, data)
      .then(function (response) {
        setDistribution({ ...distribution, saving: false });
        var d = response.data;

          setSerials({ items: [] });
          setOrganization2({ ...orderOrganization, value: {} });
          setMovement(null);
          setDistribution({
            ...distribution,
            open: false,
          });

        notify("success", response.data.message);
      })
      .catch(function (error) {
        console.log(error);
        setDistribution({ ...distribution, saving: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  //////////////////////


  ////////////////////////
  const sellStock = () => {
    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    const data = {
      movement_type: "SALE",
      organization_id: orderOrganization.value.organization_id,
      commuter_id: "",
      provider_id: stockItems.selected.organizationId,
      items: [
        {
          item_id: stockItems.selected.itemId,
          item_type:stockItems.selected?.itemTypeName,
          quantity: serials.items?.length,
          serial_numbers: serials.items,
        },
      ],
    };
    setDistribution({
      ...distribution,
      saving: true,
      status: "Initializing sale...",
    });
    console.log("Selling....");

    createInstance
      .post(new ReportingService().SELL_STOCK, data)
      .then(function (response) {
        setDistribution({ ...distribution, saving: false });
        var d = response.data;
        console.log(d);

        getStockItem();
        setSerials({ items: [] });
        setOrganization2({ ...orderOrganization, value: {} });
        setMovement(null);
        setDistribution({
          ...distribution,
          open: false,
        });

        notify("success", response.data.message);
      })
      .catch(function (error) {
        console.log(error);
        setDistribution({ ...distribution, saving: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  return (
    <div className={classes.root}>
      {/* Dialogs ends here */}

      <Dialog aria-labelledby="simple-dialog-title" open={distribution.saving}>
        <DialogContent>
          <Box p={2} display="flex" alignItems="center">
            <CircularProgress color="primary" />
            <Box pl={2}>
              <Typography color="textSecondary">
                {distribution.status}
              </Typography>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* /////////////////////////////////////////////////////////// */}
      <Dialog
        open={stocks.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={() => setStocks({ ...stocks, open: false })}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">{"Create new stock"}</DialogTitle>
        <DialogContent>
          <Box mt={2}>
            <Autocomplete
              fullWidth
              openOnFocus
              options={orgs}
              getOptionLabel={(option) => option.name}
              onChange={onOrganizationChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  label={
                    <Translate id="inventory.forms.labels.stock_organization" />
                  }
                  variant="outlined"
                  size="small"
                  helperText={stockOrganization.error}
                  error={stockOrganization.error !== ""}
                />
              )}
            />
          </Box>
          <Box mt={2}>
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              error={
                stockItem.error !== "" ||
                (allItems.data.length == 0 && !allItems.loading)
              }
              disabled={allItems.data.length == 0 && !allItems.loading}
            >
              <InputLabel>
                <Translate id="inventory.forms.labels.stock_item" />
              </InputLabel>
              <Select
                label={<Translate id="inventory.forms.labels.stock_item" />}
                value={stockItem.value}
                onChange={onItemChange}
              >
                {allItems.data.map((it, i) => (
                  <MenuItem value={it.id}>{it.name}</MenuItem>
                ))}
              </Select>
              <FormHelperText>
                {allItems.data.length == 0 && !allItems.loading
                  ? "There are no items categories, create one first"
                  : stockItem.error}
              </FormHelperText>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setStocks({ ...stocks, open: false })}
          >
            <Translate id="commissions.forms.buttons.cancel" />
          </Button>
          <Button
            variant="contained"
            color="primary"
            disableElevation
            autoFocus
            onClick={onCreateStockClick}
            disabled={stocks.saving}
          >
            {stocks.saving ? (
              <CircularProgress size={23} />
            ) : (
              <Translate id="commissions.forms.buttons.create" />
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* /////////////////////////////////// */}

      <Dialog
        open={allItems.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={() => setAllItems({ ...allItems, open: false })}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {"Create new item category"}
        </DialogTitle>
        <DialogContent>
          <Box mt={2}>
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              error={
                itemType.error !== "" ||
                allItemTypes.status == "error" ||
                allItemTypes.status == "empty"
              }
              disabled={
                allItemTypes.status == "error" || allItemTypes.status == "empty"
              }
            >
              <InputLabel>
                <Translate id="inventory.forms.labels.item_type" />
              </InputLabel>
              <Select
                label={<Translate id="inventory.forms.labels.item_type" />}
                value={itemType.value}
                onChange={onTypeChange}
              >
                {allItemTypes.data?.map((tp, i) => (
                  <MenuItem value={tp.id}>{tp.name}</MenuItem>
                ))}
              </Select>
              <FormHelperText>
                {allItemTypes.status == "error"
                  ? "Error loading item types, try reloading"
                  : allItemTypes.status == "empty"
                  ? "There are not item types available,create one first"
                  : itemType.error}
              </FormHelperText>
            </FormControl>
          </Box>
          <Box mt={2}>
            <Translate>
              {({ translate }) => (
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="text"
                  value={itemName.value}
                  placeholder={translate("inventory.forms.hints.item_name")}
                  label={<Translate id="inventory.forms.labels.item_name" />}
                  fullWidth
                  onChange={onNameChange}
                  helperText={itemName.error}
                  error={itemName.error !== ""}
                />
              )}
            </Translate>
          </Box>
          <Box mt={2}>
            <Translate>
              {({ translate }) => (
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="text"
                  value={itemPrice.value}
                  placeholder={translate("inventory.forms.hints.item_price")}
                  label={<Translate id="inventory.forms.labels.item_price" />}
                  fullWidth
                  onChange={onPriceChange}
                  helperText={itemPrice.error}
                  error={itemPrice.error !== ""}
                />
              )}
            </Translate>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setAllItems({ ...allItems, open: false })}
          >
            <Translate id="commissions.forms.buttons.cancel" />
          </Button>
          <Button
            variant="contained"
            color="primary"
            disableElevation
            autoFocus
            onClick={onCreateItemClick}
            disabled={allItems.saving}
          >
            {allItems.saving ? (
              <CircularProgress size={23} />
            ) : (
              <Translate id="commissions.forms.buttons.create" />
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* /////////////////////////////////// */}

      <Dialog
        open={allItemTypes.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={() => setAllItemTypes({ ...allItemTypes, open: false })}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {
            <Box display="flex" alignItems="center">
              <Box flexGrow={1}>All item types</Box>

              <Button
                color="primary"
                startIcon={<Add />}
                onClick={(e) =>
                  setAllItemTypes({ ...allItemTypes, acnhor: e.currentTarget })
                }
              >
                Add new
              </Button>
            </Box>
          }
        </DialogTitle>
        <DialogContent>
          {allItemTypes.status == "error" || allItemTypes.status == "empty" ? (
            <Box p={5} display="flex" justifyContent="center">
              {allItemTypes.status == "error" ? (
                <Typography>
                  Error loading item types, try to refresh
                </Typography>
              ) : (
                <Typography>
                  There are no item types available, create one first.
                </Typography>
              )}
            </Box>
          ) : (
            <List>
              {allItemTypes.status != "loading"
                ? allItemTypes.data?.map((tp, i) => (
                    <>
                      {i != 0 && i != allItemTypes.data?.length && (
                        <Divider variant="middle" />
                      )}
                      <ListItem
                        key={i}
                        dense
                        button
                        // onMouseEnter={() =>
                        //   setItemOver({ index: i, priv: priv, role: false })
                        // }
                        // onMouseLeave={() => setItemOver("none")}
                        // onClick={(e) => setAnchorEditPriv(e?.currentTarget)}
                        // selected={itemOver.index == i}
                      >
                        <ListItemText
                          primary={tp.name}
                          secondary={tp.description}
                        />
                        <ListItemSecondaryAction>
                          <IconButton>
                            <Edit />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                    </>
                  ))
                : [1, 2, 3, 4, 5].map((item, i) => (
                    <ListItem key={i}>
                      <ListItemText
                        primary={
                          <Skeleton
                            variant="text"
                            width={"100%"}
                            style={{ borderRadius: 7 }}
                          />
                        }
                      />
                    </ListItem>
                  ))}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            color="primary"
            onClick={() => setAllItemTypes({ ...allItemTypes, open: false })}
          >
            <Translate id="commissions.forms.buttons.cancel" />
          </Button>
        </DialogActions>
      </Dialog>

      {/* /////////////////////////////////// */}

      <Dialog
        open={stockItems.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={() =>
          setStockItems({ ...stockItems, open: false, upload: null })
        }
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {
            <Box display="flex" alignItems="center">
              <Box flexGrow={1}>Add items in stock</Box>

              {stockItems.upload && (
                <Button color="primary" startIcon={<GetApp />}>
                  Get file template
                </Button>
              )}
            </Box>
          }
        </DialogTitle>
        <DialogContent>
          {stockItems.upload ? (
            <Box mb={2} display="flex" justifyContent="center">
              <Dropzone
                onDrop={(acceptedFiles) => {
                  console.log(JSON.stringify(acceptedFiles));
                  setChoosenFile(
                    acceptedFiles.map((file) =>
                      Object.assign(file, {
                        preview: URL.createObjectURL(file),
                      })
                    )
                  );
                  setStockItems({ ...stockItems, newData: [] });
                }}
                accept=".csv,.xls,.xlsx,.ods, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                multiple={false}
                noClick={choosenFile.length != 0}
              >
                {({
                  getRootProps,
                  getInputProps,
                  isDragActive,
                  isDragReject,
                }) => (
                  <CardActionArea disableRipple={choosenFile.length != 0}>
                    {" "}
                    <Box
                      borderRadius="borderRadius"
                      p={2}
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      style={{ border: "dashed 1px grey" }}
                      {...getRootProps()}
                    >
                      {
                        <Box mr={2}>
                          {choosenFile.length != 0 ? (
                            <Description fontSize="large" color="primary" />
                          ) : (
                            <Attachment fontSize="large" color="action" />
                          )}
                        </Box>
                      }
                      <input {...getInputProps()} />

                      {choosenFile.length != 0 ? (
                        <Box display="flex" alignItems="center">
                          <Typography color="primary">
                            {choosenFile[0].name}
                          </Typography>
                          <IconButton onClick={() => setChoosenFile([])}>
                            <Close />
                          </IconButton>
                        </Box>
                      ) : (
                        !isDragActive && (
                          <Typography color="textPrimary">
                            Drop the file here or click to upload...
                          </Typography>
                        )
                      )}

                      {isDragActive && !isDragReject && (
                        <Typography color="primary">Drop it here!</Typography>
                      )}
                      {isDragReject && (
                        <Typography color="error">
                          File type not accepted, sorry!
                        </Typography>
                      )}
                    </Box>
                  </CardActionArea>
                )}
              </Dropzone>
            </Box>
          ) : stockItems.batches ? (
            <Box mt={2}>
              <Box mt={2}>
                <Translate>
                  {({ translate }) => (
                    <TextField
                      size="small"
                      variant="outlined"
                      color="primary"
                      type="text"
                      value={batchNumber.value}
                      placeholder={translate(
                        "inventory.forms.hints.batch_number"
                      )}
                      label={
                        <Translate id="inventory.forms.labels.batch_number" />
                      }
                      fullWidth
                      onChange={onNumberChange}
                      helperText={batchNumber.error}
                      error={batchNumber.error !== ""}
                    />
                  )}
                </Translate>
              </Box>
              <Box mt={2}>
                <Translate>
                  {({ translate }) => (
                    <TextField
                      size="small"
                      variant="outlined"
                      color="primary"
                      type="text"
                      value={batchSize.value}
                      placeholder={translate(
                        "inventory.forms.hints.batch_size"
                      )}
                      label={
                        <Translate id="inventory.forms.labels.batch_size" />
                      }
                      fullWidth
                      onChange={onSizeChange}
                      helperText={batchSize.error}
                      error={batchSize.error !== ""}
                    />
                  )}
                </Translate>
              </Box>
              <Box mt={2}>
                <Translate>
                  {({ translate }) => (
                    <TextField
                      size="small"
                      variant="outlined"
                      color="primary"
                      type="text"
                      value={batchStartItem.value}
                      placeholder={translate(
                        "inventory.forms.hints.batch_start_item"
                      )}
                      label={
                        <Translate id="inventory.forms.labels.batch_start_item" />
                      }
                      fullWidth
                      onChange={onStartItemChange}
                      helperText={batchStartItem.error}
                      error={batchStartItem.error !== ""}
                    />
                  )}
                </Translate>
              </Box>
              <Box mt={2}>
                <Translate>
                  {({ translate }) => (
                    <TextField
                      size="small"
                      variant="outlined"
                      color="primary"
                      type="text"
                      value={batchEndItem.value}
                      placeholder={translate(
                        "inventory.forms.hints.batch_end_item"
                      )}
                      label={
                        <Translate id="inventory.forms.labels.batch_end_item" />
                      }
                      fullWidth
                      onChange={onEndItemChange}
                      helperText={batchEndItem.error}
                      error={batchEndItem.error !== ""}
                    />
                  )}
                </Translate>
              </Box>
              <Box mt={2}>
                <Translate>
                  {({ translate }) => (
                    <TextField
                      size="small"
                      variant="outlined"
                      color="primary"
                      type="text"
                      value={batchDamagedQuantity.value}
                      placeholder={translate(
                        "inventory.forms.hints.batch_damaged_quantity"
                      )}
                      label={
                        <Translate id="inventory.forms.labels.batch_damaged_quantity" />
                      }
                      fullWidth
                      onChange={onDamagedQuantityChange}
                      helperText={batchDamagedQuantity.error}
                      error={batchDamagedQuantity.error !== ""}
                    />
                  )}
                </Translate>
              </Box>
            </Box>
          ) : (
            <>
              <form onSubmit={onSerialFormSubmit}>
                <Box mt={2} display="flex" alignItems="center">
                  <Translate>
                    {({ translate }) => (
                      <TextField
                        size="small"
                        variant="outlined"
                        color="primary"
                        type="text"
                        value={itemSerialNumber.value}
                        placeholder={translate(
                          "inventory.forms.hints.item_serial_number"
                        )}
                        label={
                          <Translate id="inventory.forms.labels.item_serial_number" />
                        }
                        fullWidth
                        onChange={onSerialNumberChange}
                        helperText={itemSerialNumber.error}
                        error={itemSerialNumber.error !== ""}
                      />
                    )}
                  </Translate>
                  <IconButton color="primary" onClick={onSerialFormSubmit}>
                    <Add />
                  </IconButton>
                </Box>
              </form>
              {stockItems.newData.length == 0 ? (
                <Box p={4}>
                  <Typography color="textSecondary" align="center">
                    Write item serial number and press Enter button, you can add
                    as many as possible.
                  </Typography>
                </Box>
              ) : (
                <List dense>
                  {stockItems.newData.map((item, i) => (
                    <>
                      {i != 0 && i != stockItems.newData?.length && (
                        <Divider variant="middle" />
                      )}
                      <ListItem key={i}>
                        <ListItemText
                          primary={item.serial}
                          secondary={item.damaged && "Damaged"}
                        />
                        <ListItemSecondaryAction>
                          <FormControlLabel
                            control={
                              <Switch
                                size="small"
                                color="primary"
                                value={item.damaged}
                                checked={item.damaged}
                                onChange={(e) => {
                                  const its = stockItems.newData;
                                  const it = its[i];

                                  it["damaged"] = !it.damaged;
                                  its[i] = it;
                                  setStockItems({
                                    ...stockItems,
                                    newData: its,
                                  });
                                }}
                              />
                            }
                            label="NoK"
                          />
                          <IconButton
                            size="small"
                            onClick={() => removeItemSerial(i)}
                          >
                            <Close fontSize="small" />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                    </>
                  ))}
                </List>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setStockItems({ ...stockItems, open: false })}
          >
            <Translate id="commissions.forms.buttons.cancel" />
          </Button>
          <Button
            className={classes.btn}
            variant="contained"
            color="primary"
            disableElevation
            autoFocus
            disabled={stockItems.saving}
            onClick={() => {
              if (stockItems.upload) {
                onUploadItemsClick();
              } else if (stockItems.batches) {
                onCreateBatchClick();
              } else {
                onAddItemsClick();
              }
            }}
          >
            {stockItems.saving ? (
              <CircularProgress size={23} />
            ) : stockItems.upload ? (
              "Upload items"
            ) : stockItems.batches ? (
              "Create batch"
            ) : (
              "Add items"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ////////////////////////////// */}

      <Popover
        id={"pop-id"}
        open={allItemTypes.acnhor != null}
        anchorEl={allItemTypes.acnhor}
        onClose={() => setAllItemTypes({ ...allItemTypes, acnhor: null })}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        elevation={4}
      >
        <Box p={2}>
          <Typography color="textSecondary">
            Create new item type to use in item categories.
          </Typography>

          {/* <Box mt={2}>
            <Translate>
              {({ translate }) => (
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="text"
                  value={typeName.value}
                  placeholder={translate("inventory.forms.hints.type_name")}
                  label={<Translate id="inventory.forms.labels.type_name" />}
                  fullWidth
                  onChange={onTypeNameChange}
                  helperText={typeName.error}
                  error={typeName.error !== ""}
                />
              )}
            </Translate>
          </Box> */}

          <Box mt={2}>
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              error={itemTypeName.error !== ""}
            >
              <InputLabel>
                <Translate id="inventory.forms.labels.item_type_name" />
              </InputLabel>
              <Select
                label={<Translate id="inventory.forms.labels.item_type_name" />}
                value={itemTypeName.value}
                onChange={onTypeNameChange}
              >
                {[
                  "POS",
                  "VALIDATOR",
                  "MOBILE_PHONE",
                  "CARD",
                  "KIOSIQUE",
                  "WEB",
                  "OTHER",
                ].map((t, i) => (
                  <MenuItem value={t}>{t}</MenuItem>
                ))}
              </Select>
              <FormHelperText>{itemTypeName.error}</FormHelperText>
            </FormControl>
          </Box>
          <Box mt={2}>
            <Translate>
              {({ translate }) => (
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="text"
                  value={typeDescription.value}
                  placeholder={translate(
                    "inventory.forms.hints.type_description"
                  )}
                  label={
                    <Translate id="inventory.forms.labels.type_description" />
                  }
                  fullWidth
                  multiline
                  rows={3}
                  rowsMax={5}
                  onChange={onTypeDescriptionChange}
                  helperText={typeDescription.error}
                  error={typeDescription.error !== ""}
                />
              )}
            </Translate>
          </Box>

          <Box display="flex" mt={2}>
            <Button
              variant="outlined"
              size="small"
              color="primary"
              className={classes.btn}
              onClick={() => setAllItemTypes({ ...allItemTypes, acnhor: null })}
            >
              Cancel
            </Button>
            <Box mr={2} />
            <Button
              disabled={allItemTypes.saving}
              variant="contained"
              color="primary"
              className={classes.btn}
              disableElevation
              onClick={() => {
                onCreateTypeClick();
              }}
            >
              {allItemTypes.saving ? <CircularProgress size={23} /> : "Save"}
            </Button>
          </Box>
        </Box>
      </Popover>

      <Box display="flex">
        <Box mr={2}>
          {" "}
          <Store color="primary" fontSize="large" />
        </Box>
        <Typography variant="h5" className={classes.title}>
          <b>Inventory</b>
        </Typography>

        {!matches ? (
          <>
            <IconButton onClick={(e) => setMenuOpen(e.currentTarget)}>
              <MoreVert />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={menuOpen}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              open={menuOpen != null}
              onClose={() => setMenuOpen(null)}
            >
              <MenuItem
                onClick={() => {
                  setAllItemTypes({ ...allItemTypes, open: true });
                }}
              >
                Item types
              </MenuItem>

              <MenuItem
                onClick={() => setAllItems({ ...allItems, open: true })}
              >
                New item
              </MenuItem>
            </Menu>
          </>
        ) : (
          <Box display="flex">
            <Button
              className={classes.btn}
              color="primary"
              size="medium"
              variant="outlined"
              startIcon={<Assignment />}
              onClick={() => {
                setAllItemTypes({ ...allItemTypes, open: true });
              }}
            >
              Item types
            </Button>
            <Box ml={2} />
            <Button
              className={classes.btn}
              color="primary"
              variant="contained"
              size="medium"
              startIcon={<Add />}
              disableElevation
              onClick={() => setAllItems({ ...allItems, open: true })}
            >
              New item
            </Button>
          </Box>
        )}
      </Box>
      <Box mt={3} />
      <Grid container spacing={2}>
        <Grid item xs={12} md={5}>
          <Box
            width={1}
            mb={2}
            display="flex"
            justifyContent="space-between"
            height="40px"
          >
            <>
              <ButtonGroup color="primary" variant="outlined">
                <Button>{anchorEl.menu == 0 ? "Stock in" : "Stock out"}</Button>
                <Button
                  onClick={(e) =>
                    setAnchorEl({ ...anchorEl, anchor: e.currentTarget })
                  }
                >
                  <ArrowDropDown />
                </Button>
              </ButtonGroup>

              <Menu
                id="menu-appbar"
                anchorEl={anchorEl.anchor}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                open={anchorEl.anchor != null}
                onClose={() => setAnchorEl({ ...anchorEl, anchor: null })}
              >
                <MenuItem
                  selected={anchorEl.menu == 0}
                  onClick={() => {
                    setAnchorEl({ ...anchorEl, menu: 0, anchor: null });
                  }}
                >
                  Stock in
                </MenuItem>
                <MenuItem
                  selected={anchorEl.menu == 1}
                  onClick={() => {
                    setAnchorEl({ ...anchorEl, menu: 1, anchor: null });
                  }}
                >
                  Stock out
                </MenuItem>
              </Menu>
            </>
            {searchMode && (
              <Box ml={1} alignSelf="flex-end">
                <TextField
                  size="small"
                  color="primary"
                  placeholder="Search stock"
                  fullWidth
                />
              </Box>
            )}
            <Box>
              <IconButton
                color="primary"
                onClick={() => setSearchMode(!searchMode)}
              >
                <Search />
              </IconButton>
            </Box>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
              >
                <CardActionArea
                  className={classes.action}
                  onClick={() => {
                    setStocks({ ...stocks, open: true });
                  }}
                >
                  <Box
                    height="70px"
                    width={1}
                    display="flex"
                    alignItems="center"
                    border={1}
                    borderStyle="dotted"
                    borderRadius="borderRadius"
                    borderColor="grey.300"
                    className={classes.btn2}
                  >
                    <Box mr={1} ml={1}>
                      <Add fontSize="default" />
                    </Box>
                    <Typography color="inherit">New stock</Typography>
                  </Box>
                </CardActionArea>
              </Box>
            </Grid>

            {stocks?.data?.length == 0 && !stocks.loading && (
              <Box
                p={2}
                mt={3}
                height={1}
                display="flex"
                alignItems="center"
                flexDirection="column"
                justifyContent="center"
              >
                <Box mt={2}>
                  <img src={Empty} alt="Empty data" height={160} />
                </Box>
                <Typography color="textSecondary">
                  There are no stocks initialized, create one first
                </Typography>
              </Box>
            )}

            {stocks.loading
              ? [1, 2, 3, 4, 5].map((o, i) => (
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      borderRadius={15}
                      width={1}
                    >
                      <Skeleton
                        variant="rect"
                        height={70}
                        width={"100%"}
                        style={{ borderRadius: 15 }}
                      />
                    </Box>
                  </Grid>
                ))
              : stocks?.data?.map((stk, i) => (
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      flexDirection="column"
                    >
                      <CardActionArea
                        className={classes.action}
                        onClick={() => {
                          setStockItems({
                            ...stockItems,
                            open: false,
                            selected: stk,
                            index: i,
                          });
                        }}
                      >
                        <Paper
                          className={classes.card}
                          elevation={0}
                          style={{
                            background:
                              stockItems?.index == i &&
                              theme.palette.type == "dark"
                                ? "#757575"
                                : stockItems?.index == i &&
                                  theme.palette.type != "dark" &&
                                  "#e0e0e0",
                          }}
                        >
                          <Box
                            height="60px"
                            width={1}
                            display="flex"
                            alignItems="center"
                            border={0}
                            className={classes.action}
                            borderColor="primary.main"
                          >
                            <Box display="flex" width={1}>
                              <Box mr={1} ml={1}>
                                <Folder fontSize="default" />
                              </Box>

                              <Box display="flex" flexDirection="column">
                                <Typography color="inherit" noWrap>
                                  {stk.ownerType}
                                </Typography>

                                <Typography
                                  color="textSecondary"
                                  variant="caption"
                                  noWrap
                                >
                                  {stk.itemName}
                                </Typography>
                              </Box>
                            </Box>

                            <Badge
                              badgeContent={stk.quantity}
                              color="primary"
                              invisible={stk.quantity == 0}
                            >
                              <Box m={1} height={30}></Box>
                            </Badge>
                          </Box>
                        </Paper>
                      </CardActionArea>
                    </Box>
                  </Grid>
                ))}
          </Grid>
          <Box width={1} mt={2} display="flex" justifyContent="center">
            <Pagination disabled count={10} color="primary" size="medium" />
          </Box>
        </Grid>

        {stockItems.selected != null ? (
          <Grid item xs={12} md={7}>
            <Box>
              <Box mb={2} display="flex" width={1} alignItems="center">
                <Box flexGrow={1}>
                  <Typography>
                    <b>{stockItems.selected.ownerType}</b>
                    {" | " + stockItems.selected.itemTypeName + " | "}
                    {stockItems.selected.itemName}
                  </Typography>
                </Box>

                <IconButton
                  onClick={() =>
                    setStockItems({
                      ...stockItems,
                      open: false,
                      selected: null,
                      index: null,
                    })
                  }
                >
                  <Close />
                </IconButton>
              </Box>
              {anchorEl.menu == 0 ? (
                <Permissions permissions="CAN_CREATE_INVENTORY_ITEM">
                  {stockItems.selected.ownerType=='CENTRIKA' &&<Box width={1} mb={2} display="flex" ml={2}>
                    <Button
                      className={classes.btn}
                      startIcon={<Add />}
                      color="primary"
                      variant="outlined"
                      disableElevation
                      onClick={() =>
                        setStockItems({
                          ...stockItems,
                          open: true,
                          upload: false,
                          batches: false,
                        })
                      }
                    >
                      Add{" "}
                      {stockItems.selected?.itemTypeName + "(s)"}
                    </Button>
                    <Box ml={2} />
                    <Button
                      className={classes.btn}
                      startIcon={<Unarchive />}
                      color="primary"
                      variant="outlined"
                      disableElevation
                      onClick={() =>
                        setStockItems({
                          ...stockItems,
                          open: true,
                          upload: true,
                        })
                      }
                    >
                      Upload {stockItems.selected?.itemTypeName + "(s)"}
                    </Button>

                    <Box ml={2} />
                    {stockItems.selected?.itemTypeName == "CARD" && (
                      <Button
                        className={classes.btn}
                        startIcon={<CalendarViewDay />}
                        color="primary"
                        variant="outlined"
                        disableElevation
                        onClick={() =>
                          setStockItems({
                            ...stockItems,
                            open: true,
                            upload: false,
                            batches: true,
                          })
                        }
                      >
                        Add batches
                      </Button>
                    )}
                  </Box>}
                </Permissions>
              ) : (
               <Box>
                  {stockItems.selected.ownerType=='CENTRIKA' &&<Box width={1} mb={2} display="flex" ml={2}>
                  <Button
                    className={classes.btn}
                    startIcon={<CallMade />}
                 
                    color="primary"
                    variant={movement=='dist'?"contained":'outlined'}
                    disableElevation
                    onClick={() => setMovement("dist")}
                  >
                    Request {stockItems.selected?.itemTypeName+"(s)"}
                  </Button>
                  <Box ml={2} />
                  <Button
                    className={classes.btn}
                    startIcon={<AttachMoney />}
                    color="primary"
                    variant={movement=='sell'?"contained":"outlined"}
                    disableElevation
                    onClick={() => setMovement("sell")}
                  >
                    Sell {stockItems.selected?.itemTypeName}
                  </Button>
                </Box>}
                </Box>
              )}

              {stockItems.selected?.items?.length == 0 ? (
                <Box
                  mt={5}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection="column"
                >
                  <Box mt={2} mb={2}>
                    <img src={Empty} alt="Empty data" height={100} />
                  </Box>
                  <Typography color="textSecondary">
                    No items in the stock yet
                  </Typography>
                </Box>
              ) : (
                <Grid container>
                  <Grid item xs={12} sm={12} md={10} lg={10}>
                    {movement != null && (
                      <Paper elevation={0}>
                        <Box m={2}>
                          <Box pt={2}>
                            <Typography variant="h5">Select items</Typography>
                          </Box>
                          <Box mt={2}>
                            <Autocomplete
                              multiple
                              rows={3}
                              id="tags-filled"
                              options={stockItems.selected?.items
                                .filter((a) => a.status == "OK")
                                .map((a) => a.serial_number)
                                .map((option) => option)}
                              value={serials.items}
                              //freeSolo
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                    variant="outlined"
                                    label={option}
                                    {...getTagProps({ index })}
                                    onDelete={() => {
                                      var sls = serials.items;
                                      sls.splice(index, 1);
                                      setSerials({ items: sls });
                                    }}
                                  />
                                ))
                              }
                              onChange={(event, newValue) => {
                                console.log(newValue);
                                setSerials({
                                  items: newValue,
                                });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  fullWidth
                                  autoFocus
                                  focused={serials.items.length != 0}
                                  margin="dense"
                                  {...params}
                                  variant="outlined"
                                  label="Serial numbers"
                                  placeholder="Write serial numbers here or select items."
                                />
                              )}
                            />
                          </Box>
                          <Box mt={2}>
                            <Autocomplete
                              fullWidth
                              openOnFocus
                              options={orgs}
                              getOptionLabel={(option) => option.name}
                              onChange={onOrganizationChange2}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  label={
                                    <Translate id="roles.forms.labels.role_organization" />
                                  }
                                  variant="outlined"
                                  size="small"
                                  helperText={orderOrganization.error}
                                  error={orderOrganization.error !== ""}
                                />
                              )}
                            />
                          </Box>
                          <Box mt={3} mb={2} display="flex">
                            <Button
                              disableElevation
                              color="primary"
                              variant="contained"
                              className={classes.btn}
                              onClick={() => {
                                if (serials.items.length == 0) {
                                  notify(
                                    "error",
                                    "Select items to distribute first"
                                  );
                                } else if (
                                  orderOrganization.value.organization_id ==
                                  null
                                ) {
                                  notify("error", "Select organization first");
                                } else {
                                  movement == "dist"
                                    ? requestStock()
                                    : sellStock();
                                }
                              }}
                            >
                              {movement == "dist"
                                ? "Request items"
                                : "Sell items"}
                            </Button>
                            <Box ml={2} />
                            <Button
                              disableElevation
                              color="primary"
                              variant="outlined"
                              className={classes.btn}
                              onClick={() => setMovement(null)}
                            >
                              Cancel
                            </Button>
                          </Box>
                          <Divider variant="middle" />
                        </Box>
                      </Paper>
                    )}

                    <Box ml={2}>
                      <Typography variant="h5">Stock items list</Typography>
                    </Box>
                    <Box>
                      <List dense>
                        {stockItems.selected?.items.map((it, i) => (
                          <>
                            {i != 0 &&
                              i != stockItems.selected?.items?.length && (
                                <Divider variant="middle" />
                              )}{" "}
                            <ListItem>
                              <ListItemIcon>
                                {movement != null ? (
                                  <Checkbox
                                    disabled={it.status != "OK"}
                                    color="primary"
                                    checked={serials.items.includes(
                                      it.serial_number
                                    )}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        const sls = serials.items;
                                        sls.push(it.serial_number);
                                        setSerials({ items: sls });
                                        console.log("checked event");
                                      } else {
                                        const sls = serials.items;
                                        const i = sls.indexOf(it.serial_number);
                                        sls.splice(i, 1);
                                        setSerials({ items: sls });
                                        console.log("Nope");
                                      }
                                    }}
                                  />
                                ) : (
                                  <Label />
                                )}
                              </ListItemIcon>
                              <ListItemText primary={it.serial_number} />
                              <ListItemSecondaryAction>
                                {it.status == "OK" ? (
                                  <CheckCircle
                                    color="primary"
                                    fontSize="small"
                                  />
                                ) : (
                                  <HighlightOff
                                    color="error"
                                    fontSize="small"
                                  />
                                )}
                              </ListItemSecondaryAction>
                            </ListItem>
                          </>
                        ))}
                      </List>
                    </Box>
                  </Grid>
                </Grid>
              )}
            </Box>
          </Grid>
        ) : (
          <Grid item xs={12} md={7}>
            <Box width={1} mb={2} display="flex">
              <Typography variant="h6">All items</Typography>
            </Box>
            {allItems.loading && <LinearProgress />}
            <MUIDataTable
              title={"List of stock items"}
              data={allItems.data}
              columns={columns}
              options={options}
            />
          </Grid>
        )}
      </Grid>
    </div>
  );
}

export default withLocalize(Inventory);
